module.exports = __webpack_public_path__ + "img/Support-skill-216.37d185ab.png";